import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { toggleInvitePeople, invitePeople, toggleModalFeedbackThanks, clearInviteSentStatus } from '../../../redux/main/main.actions';
import { selectIsModalInvitePeopleEnabled, selectInviteSentStatus } from '../../../redux/main/main.selectors';

import { showNotify } from '../../../redux/notify/notify.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalInvitePeople.scss';

export const ModalInvitePeople = () => {
    const history = useHistory();
    const isOpen = useSelector(selectIsModalInvitePeopleEnabled);

    const dispatch = useDispatch();

    const inputRef = useRef(null);
    const [value, setValue] = useState('');

    const inviteSentStatus = useSelector(selectInviteSentStatus);
    const [sentCount, setSentCount] = useState(0);

    useEffect(() => {
        if (inviteSentStatus === 'success') {
            trackEvent('app_modal_invite_people_submit_ok', {
                page: 'app',
                type: 'modals',
            });
            dispatch(toggleInvitePeople(null));
            dispatch(toggleModalFeedbackThanks('invite_people', 'main'));

            setTimeout(() => {
                setValue('');
                setSentCount(0);
            }, 300);

        } else if (inviteSentStatus === 'error') {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }

        return () => {
            dispatch(clearInviteSentStatus());
        };
    }, [inviteSentStatus]);


    const handleSave = () => {
        trackEvent('app_modal_invite_people_submit', {
            page: 'app',
            type: 'modals',
        });
        if (!value) {
            dispatch(showNotify({ message: 'please_enter_email' }));
            if (inputRef.current) {
                inputRef.current.focus();
            }
            return;
        }
        if (!validateEmail(value)) {
            dispatch(showNotify({ message: 'invalid_email' }));
            if (inputRef.current) {
                inputRef.current.focus();
            }
            return;
        }

        if (sentCount > 4) return;

        setSentCount(sentCount + 1);
        dispatch(invitePeople(value));

        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleCancel = () => {
        dispatch(toggleInvitePeople(null));
        setTimeout(() => {
            setValue('');
            setSentCount(0);
        }, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        }
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            // inputRef.current.focus();
        }
    };

    const handleChange = (e) => {
        if (e.target.value?.length < 150) {
            setValue(e.target.value);
        }
    }

    const validateEmail = (emailValue) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(emailValue);
    };

    const handleBottomLinkClick = () => {
        dispatch(toggleInvitePeople(null));
        const url = `/settings/usage/`;
        history.push(url);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-invite-people`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{`Invite members to the workspace`}</div>
            <div className="modal-content-body">

                <div className="form-group-invite">
                    <input
                        maxLength="150"
                        autoFocus={(window.innerWidth >= 1000)}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        inputMode="text"
                        ref={inputRef}
                        placeholder="Enter email address"
                        value={value}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                    />
                    <button disabled={sentCount > 4} onClick={() => handleSave()}>Invite</button>
                </div>

                {/* <div className='bottom-section'>
                    <div className='bottom-section-left'>
                        <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 11V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V11M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15.8C21 14.1198 21 13.2798 20.673 12.638C20.3854 12.0735 19.9265 11.6146 19.362 11.327C18.7202 11 17.8802 11 16.2 11H7.8C6.11984 11 5.27976 11 4.63803 11.327C4.07354 11.6146 3.6146 12.0735 3.32698 12.638C3 13.2798 3 14.1198 3 15.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"></path></svg>
                        <div className='bottom-section-left-text'>
                            <span className="bottom-section-left-text-subtitle">Inviting additional members may increase your team’s license count and will be reflected in your next bill.<span className='bottom-section-left-text-link' onClick={(e) => { handleBottomLinkClick(); }}>See usage.</span>
                            </span>
                        </div>
                    </div>
                </div> */}

            </div>
        </Modal>
    );
};

export default ModalInvitePeople;
